import React from 'react'
import LearnMoreLogo from '.././../../../Assets/Images/LearnMoreLogo-removebg-preview.png'
import learnmoreThumb from '.././../../../Assets/Images/learnmorethumb.png'
import "./LearnMore.css";
import learnmoreimg from "../../../../Assets/Images/image-removebg-preview.png";
                                                                                                                                                        
export default function LearnMore() {
    return (
        <div className='learnmore' id="about">
            <div className="container">
                <div className="learnmore-top">
                    <img src={LearnMoreLogo} alt="" className="learnmore-logo" />
                    <h2 className="learnmore-title">
                        A Multi <b> Agri-commodity </b> Processing company  with ,
                    </h2>
                    <img src={learnmoreThumb} alt="" className="learnmore-thumb" />
                </div>
                <div className="learnmore-bottom">
                    <ul className="learnmore-list">
                  <div className='learnmore-flex'>
                        <li className="learnmore-item">
                           <div className='learnmore-header'>
                             <h3 className="learnmore-subtitle">
                            World class infrastructure.
                            </h3>
                            <span className='learnmore-number'>
                            01
                            </span>
                            </div>
                            <p className="learnmore-subtext">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum.
                            </p>
                            <a href="#" className="learnmore-link">
                            learn more
                            </a>
                        </li>
                        <li className="learnmore-item">
                           <div className='learnmore-header'> <h3 className="learnmore-subtitle">
                            World class infrastructure.
                            </h3>
                            <span className='learnmore-number'>
                            03
                            </span>
                            </div>
                            <p className="learnmore-subtext">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum.
                            </p>
                            <a href="#" className="learnmore-link">
                            learn more
                            </a>
                        </li>
                        </div>
                        <span className='learnmore-hr'></span>
                        <div className='learnmore-flex'>
                        <li className="learnmore-item">
                           <div className='learnmore-header'>
                             <h3 className="learnmore-subtitle">
                            World class infrastructure.
                            </h3>
                            <span className='learnmore-number'>
                            02
                            </span>
                            </div>
                            <p className="learnmore-subtext">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum.
                            </p>
                            <a href="#" className="learnmore-link">
                            learn more
                            </a>
                        </li>
                        <li className="learnmore-item">
                           <div className='learnmore-header'> <h3 className="learnmore-subtitle">
                            World class infrastructure.
                            </h3>
                            <span className='learnmore-number'>
                            04
                            </span>
                            </div>
                            <p className="learnmore-subtext">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum.
                            </p>
                            <a href="#" className="learnmore-link">
                            learn more
                            </a>
                        </li>
                        </div>
                    </ul>
                </div>
            </div>

        </div>
    )
}
